import Axios from 'axios';
import {router} from './../../main.js';

export default {
  user: {
    authenticated: false,
    profile: null,
    hasRole_carowner: false,
    hasRole_administrative: false,
    hasRole_runner: false,
    hasRole_keyguard: false,
    hasRole_assup: false,
    hasRole_supervisor: false,
    hasRole_operasional: false,
    hasRole_keuangan: false,
    hasRole_adminsite: false,
    hasRole_mod: false,
    hasRole_adminsystem: false
  }, /*
  check() {
    if (localStorage.getItem('id_token') !== null) {
      Vue.http.get(
                '/me',
            ).then((response) => {
              this.user.authenticated = true;
              this.user.profile = response.data.data;
            });
    }
  },
  register(context, name, email, password) {
    Vue.http.post(
            'api/register',
      {
        name: name,
        email: email,
        password: password
      }
        ).then((response) => {
          context.success = true;
          console.log(response);
        }, (response) => {
          context.response = response.data;
          context.error = true;
          console.log(response);
        });
  },
  signin(context, email, password) {
    Vue.http.post(
            'authenticate',
      {
        email: email,
        password: password
      }
        ).then((response) => {

          context.error = false;
          localStorage.setItem('id_token', response.data.meta.token);
          Vue.http.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('id_token');

          this.user.authenticated = true;
          this.user.profile = response.data.data;

          console.log(response.data.data);

          router.push({
            name: 'landing'
          });

        }, (response) => {
          context.error = true;
          console.log(response);
        });
  },*/
  signout() {
    Axios.get('/signout').then(() => {
      localStorage.removeItem('id_token');
      this.user.authenticated = false;
      this.user.profile = null;

      router.push({
        name: 'signin'
      });
    }, (error) => {
      console.log(error);
    });
  },
  signin(context, email, password) {
    Axios.post('authenticate', {
      email: email,
      password: password
    }).then((response) => {

      context.error = false;
      localStorage.setItem('id_token', response.data.meta.token);
      Axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('id_token');

      this.user.authenticated = true;
      this.user.profile = response.data.data;

      // Reset Role
      this.user.hasRole_carowner = false;
      this.user.hasRole_administrative = false;
      this.user.hasRole_runner = false;
      this.user.hasRole_keyguard = false;
      this.user.hasRole_assup = false;
      this.user.hasRole_supervisor = false;
      this.user.hasRole_operasional = false;
      this.user.hasRole_keuangan = false;
      this.user.hasRole_adminsite = false;
      this.user.hasRole_mod = false;
      this.user.hasRole_adminsystem = false;

      for (let has_role of response.data.data.has_role) {
        switch ( has_role.rlms_id ) {
          case 99:
            this.user.hasRole_adminsystem = true;
            break;
          case 90:
            this.user.hasRole_mod = true;
            break;
          case 80:
            this.user.hasRole_adminsite = true;
            break;
          case 70:
            this.user.hasRole_keuangan = true;
            break;
          case 60:
            this.user.hasRole_operasional = true;
            break;
          case 55:
            this.user.hasRole_supervisor = true;
            break;
          case 50:
            this.user.hasRole_assup = true;
            break;
          case 40:
            this.user.hasRole_keyguard = true;
            break;
          case 30:
            this.user.hasRole_runner = true;
            break;
          case 20:
            this.user.hasRole_administrative = true;
            break;
          case 10:
            this.user.hasRole_carowner = true;
            break;
          default:
            this.user.hasRole_carowner = false;
            this.user.hasRole_administrative = false;
            this.user.hasRole_runner = false;
            this.user.hasRole_keyguard = false;
            this.user.hasRole_assup = false;
            this.user.hasRole_supervisor = false;
            this.user.hasRole_operasional = false;
            this.user.hasRole_keuangan = false;
            this.user.hasRole_adminsite = false;
            this.user.hasRole_mod = false;
            this.user.hasRole_adminsystem = false;
        }
      }

      router.push({
        name: 'maps'
      });

    }, (error) => {
      context.error = true;
      console.log(error);
    });
  }
};



// WEBPACK FOOTER //
// ./src/scripts/modules/auth.js